import React from "react";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";
import { CheckCircle2 } from "lucide-react";

/**
 * ResolveIncidentModal — Diálogo de resolución de una incidencia.
 *
 * Extraído 1:1 desde `pages/IncidentsPage.js`. Exige un resumen de la solución antes de
 * marcar la incidencia como RESUELTO.
 *
 * @param {boolean}  props.resolveModalOpen      Apertura del diálogo.
 * @param {Function} props.setResolveModalOpen    Setter del flag de apertura.
 * @param {string}   props.resolutionSummary      Texto del resumen de la solución.
 * @param {Function} props.setResolutionSummary   Setter del resumen.
 * @param {Function} props.handleResolveIncident  Confirma la resolución de la incidencia.
 */
export const ResolveIncidentModal = ({
  resolveModalOpen,
  setResolveModalOpen,
  resolutionSummary,
  setResolutionSummary,
  handleResolveIncident,
}) => {
  return (
      <Dialog open={resolveModalOpen} onOpenChange={setResolveModalOpen}>
        <DialogContent className="bg-[#0A0A35] border-[#1E1E5F] text-white">
          <DialogHeader>
            <DialogTitle className="text-white font-heading flex items-center gap-2">
              <CheckCircle2 className="h-5 w-5 text-green-400" />
              Resolver Incidencia
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 mt-4">
            <p className="text-slate-300">
              Para marcar esta incidencia como resuelta, debes proporcionar un resumen de la solución.
            </p>
            <div>
              <Label className="text-slate-300">Resumen de la Solución *</Label>
              <Textarea
                value={resolutionSummary}
                onChange={(e) => setResolutionSummary(e.target.value)}
                placeholder="Describe cómo se resolvió el problema..."
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white h-32"
              />
            </div>
          </div>
          <DialogFooter className="mt-6">
            <Button
              variant="outline"
              onClick={() => {
                setResolveModalOpen(false);
                setResolutionSummary("");
              }}
              className="border-[#1E1E5F] text-slate-300"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleResolveIncident}
              className="bg-green-500 text-white hover:bg-green-600"
            >
              <CheckCircle2 className="h-4 w-4 mr-2" />
              Resolver Incidencia
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};
